import { useCurrentAccountDetails } from 'api/current-account/currentAccount.hooks'
import { GlobalContext } from 'legacy/contexts/global/GlobalContext'
import { useRequiredContext } from 'legacy/contexts/utils'
import { useWarehouseContext } from 'utils/contexts/warehouse/WarehouseContext.hooks'

export const useRequiredNavDataLoadingStatus = () => {
  // the nav uses these contexts to determine which nav items to render
  // we wait for them to be loaded to avoid UI flashing

  // After the flippers are migrated out of the global context this can be removed
  const globalContext = useRequiredContext(GlobalContext)
  const { loading } = useCurrentAccountDetails()
  const warehouseContext = useWarehouseContext()

  if (loading || !globalContext.user || !warehouseContext.warehouse) {
    return {
      loading: true,
      error: null,
    }
  }

  return {
    loading: false,
    error: null,
  }
}

// Admin nav requires user on the global context (to load flippers) and account (to load permissions)
export const useRequiredAdminNavDataLoadingStatus = () => {
  // After the flippers are migrated out of the global context this can be removed
  const globalContext = useRequiredContext(GlobalContext)
  const { loading } = useCurrentAccountDetails()

  return {
    loading: !globalContext.user || loading,
    error: null,
  }
}
